import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import {Helmet} from 'react-helmet';
import './ugiElectricityPage.scss';

/**
 * The UgiElectricityPage component.
 *
 * @constructor
 */
export class UgiElectricityPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="ugi-electricity-page" className="system-page">
        <Helmet>
          <title>Electric Utilities - NEI</title>
          <meta name = "description" content ='The majority of power lines are aerial, but "undergrounding" is becoming more popular, especially in urban areas, with lines being buried underground.' />
        </Helmet>
        <div className="container-fluid">
          <div className="row row-odd">
            <div className="container">
              <div className="row">
                <div className="col">
                  <p>Electricity is generated in power plants, by solar or wind farms, and through hydroelectric dams. Once generated, it moves through a grid of substations, transformers, and power lines that connect electric companies to consumers, both residential and commercial. Most local grids are interconnected, and form larger networks that are used to plan and coordinate electricity supply. The United States has three main interconnected systems.</p>
                  <p>Some utility companies generate all of the electricity they need to supply their customers and sell the remainder, while others with less generating capacity may need to purchase the electricity required to meet their customers’ needs from other utilities or independent power producers. The vast majority of power lines are aerial (overhead), but "undergrounding" is becoming more popular, especially in urban areas, with lines being buried underground.</p>
                  <p className="last">What isn’t as easy to see is the 200,000+ miles of high-voltage power lines, which is enough to wrap around the earth more than eight times!</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-even">
            <div className="container">
              <div className="row h-100">
                <div className="col my-auto">
                  <h1>Resource Links</h1>
                  <p><a href="http://www.eei.org/issuesandpolicy/transmission/Pages/default.aspx" target="_blank">eei.org</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UgiElectricityPage.propTypes = {};

export default UgiElectricityPage;



// WEBPACK FOOTER //
// ./src/components/pages/ugiElectricity/UgiElectricityPage.js